import {mapActions, mapMutations, mapState} from 'vuex'
import {checkBankCardNo, checkBaseBankCardNo, convertCurrency, formatMoney} from '@/utils/ruoyi'
import store from '@/store'
import {
    agreeAPI,
    chgAssignee,
    commentAPI,
    counterSign,
    flowStartAPI,
    onBackAPI,
    refuseAPI,
    rejectFlowAPI,
    saveForm,
    taskRevoke
} from '@/api/flow'
import axios from "axios";
import {getTicket} from "@/api/file";
import * as ww from "@wecom/jssdk";

export default {
    data() {
        return {
            imageTypeList: ['png', 'jpg', 'jpeg', 'gif', 'webp'],
            documentTypeList: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'],
        }
    },
    computed: {
        ...mapState({
            image_base_url: state => state.settings.image_base_url,
            processData: state => state.process.processData,
            perms: state => state.process.perms,
            submitInfo: state => state.process.submitInfo,
            templateId: state => state.process.templateId,
            groupId: state => state.process.groupId,
            processNode: state => state.process.processNode,
            processInstanceId: state => state.process.processInstanceId,
            flowTrace: state => state.process.flowTrace,
            taskId: state => state.process.taskId
        })
    },
    created() {
    },
    methods: {
        ...mapActions({
            getFormInfo: 'process/getFormInfo',
            // 获取流程
            getProcessInfo: 'process/getProcessInfo'
        }),
        ...mapMutations({
            SET_TEMPLATE_ID: 'process/SET_TEMPLATE_ID',
            SET_GROUP_ID: 'process/SET_GROUP_ID',
            SET_PROCESS_NODE: 'process/SET_PROCESS_NODE',
            SET_PROCESS_INSTANCE_ID: 'process/SET_PROCESS_INSTANCE_ID',
            SET_TASK_ID: 'process/SET_TASK_ID',
            CLEAR: 'process/CLEAR'
        }),
        // 判断流程跟踪选人多选单选状态
        approverCheckChange(e, node) {
            if (!this.processNode.multiple) { // 多选
                this.singleChoice(e, node)
            }
        },
        isShowIcon(field) {
            return this.perms?.find(item => item.id === field)?.perm === 'E'
        },
        // 流程跟踪选人确认
        approverPopupSubmit() {
            const list = this.$refs.approverTree.getCheckedNodes()
            const node = {
                [this.processNode.id]: list
            }
            // 手动push进子组件
            this.$refs.approver.pushUsers(node)
            this.approver.show = false
        },
        addUser(node) {
            this.approver.show = true
            this.$nextTick(() => {
                this.SET_PROCESS_NODE(node)
                // 置空所有已经勾选的节点
                this.$refs.approverTree.setCheckedKeys([])
            })
        },
        handlePopupCheckboxCellToggle(dom, index) {
            this.$refs[dom][index].toggle()
        },
        /**
         *
         * @param type 流程类型
         * @param text 名称
         * @param fn 流程发起函数句柄
         * @param comments 评论和意见
         * @param transferUserInfo 转办人员信息
         * @param isRedirect 是否跳转
         * @param redirectQuery 跳转的参数
         * @param multiAddUserInfo 加签人信息
         * @returns {Promise<void>}
         */
        async submit({type, text, fn, comments, transferUserInfo, isRedirect, redirectQuery, multiAddUserInfo}) {
            console.log(type)
            const isSubmit = type === 'save' ? false : true;
            let isConfirm = false;
            // 流程跟踪选人校验
            if (type === 'start' || type === 'save') {
                // 报销
                if (this.groupId == 5) {
                // if (this.groupId == 5|| this.groupId == 31) {
                    let formValidatorBool= this.formValidator()
                    if(!formValidatorBool){
                        return
                    }
                }
                if(this.$refs.approver){
                    try {
                        await Promise.all(this.$refs.approver.getAllRequiredPromiseList())
                    } catch (err) {
                        console.log(err)
                        this.$loading.hide()
                        this.$toast(`请选择 “${err.title}” 节点办理人`)
                        return
                    }
                }
               
            }
            //判断是否是差旅补助流程
            if (this.groupId == 26) {
                if (!this.validateOverLap()) {
                    return
                }
            }

            try {
                // 需要校验的提交类型（start、agree），拒绝、撤销等则不需要校验
                const validateTypeList = ['save', 'start']
                const zffsTypeList = ['agree']
                if (validateTypeList.includes(type) || zffsTypeList.includes(type)) {
                    await this.$refs.form.validate()
                }
                if (validateTypeList.includes(type)) {
                    // 开票：校验开票金额和开票信息明细金额之和
                    if (this.groupId == 7) {
                        this.validateAmountSum()
                    }

                    // 校验报销 差旅报销 付款 账户信息
                    let baseCardCheck = this.formData.skryhzh ? this.verifyBaseBankCardNo(this.formData.skryhzh) : this.formData.fkzh ? this.verifyBaseBankCardNo(this.formData.fkzh) : this.formData.yhzh ? this.verifyBaseBankCardNo(this.formData.yhzh) : null
                    if (baseCardCheck) {
                        this.$notify({type: 'warning', message: baseCardCheck});
                        return
                    }
                    let bankCardCheck = this.formData.skryhzh ? this.verifyBankCardNo(this.formData.skryhzh) : this.formData.fkzh ? this.verifyBankCardNo(this.formData.fkzh) : this.formData.yhzh ? this.verifyBankCardNo(this.formData.yhzh) : null
                    if (bankCardCheck) {
                        await this.$dialog.confirm({message: '<strong>请仔细核实收款账号，错误或不匹配的的账号、账户名、开户行会影响转账，确认提交吗？</strong>'}).then(async () => {
                            // 提交函数
                            await this[fn](isSubmit, comments, transferUserInfo || multiAddUserInfo)
                            isConfirm = true
                        }).catch(err => {
                            this.$toast('取消提交')
                            isConfirm = false
                        })
                    } else {
                        // 提交函数
                        await this[fn](isSubmit, comments, transferUserInfo || multiAddUserInfo)
                        isConfirm = true
                    }
                } else if (zffsTypeList.includes(type)) {
                    // 报销：校验资产分摊
                    if (this.groupId == 5) {
                        this.validateApportion()
                    }

                    if (this.formData.zffsmxb) {
                        if (this.formData.zffsmxb && this.formData.zffsmxb.length > 1) {
                            this.$toast('出款账户只能选择一个')
                            isConfirm = false
                        } else {
                            // 校验通过，提交函数
                            await this[fn](isSubmit, comments, transferUserInfo || multiAddUserInfo)
                            isConfirm = true
                        }
                    } else {
                        // 提交函数
                        await this[fn](isSubmit, comments, transferUserInfo || multiAddUserInfo)
                        isConfirm = true
                    }
                } else {
                    // 提交函数
                    await this[fn](isSubmit, comments, transferUserInfo || multiAddUserInfo)
                    isConfirm = true
                }
                if (isConfirm) {
                    if (isRedirect && redirectQuery) {
                        /**
                         * interface redirectQuery {
                         *   path:string;
                         *   query:object;
                         * }
                         */
                        this.$router.push(redirectQuery)
                    } else if (this.$route.query.lastPage) {
                        this.$router.push({
                            path: this.$route.query.lastPage,
                            query: {
                                tableIndex: this.$route.query.tableIndex || 0
                            }
                        })
                    } else { // 默认跳转方式

                        this.$router.push({
                            path: '/myWork?flagClose=1', // 跳转我的流程
                            query: {
                                templateId: this.templateId,
                                groupId: this.groupId
                            }
                        })
                    }
                    // 清除上一个流程的所有缓存信息
                    this.CLEAR()
                    this.$loading.hide()
                }
            } catch (e) {
                this.$loading.hide()
                console.error(e, 'submit')
                // this.$toast('表单填写有误，请检查后重新提交')
                this.$toast(e[0].message)
            }
        },
        verifyBankCardNo(cardNo) {
            if (!cardNo || cardNo == "") {
                return "账号为空";
            }
            let result = checkBankCardNo(cardNo);
            return result;
        },
        verifyBaseBankCardNo(cardNo) {
            if (!cardNo || cardNo == "") {
                return "账号为空";
            }
            let result = checkBaseBankCardNo(cardNo);
            return result;
        },
        // 保存表单 必须是已有流程
        save(isSubmit) {
            const data = {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                formData: this.formData,
            };
            return new Promise(async (resolve, reject) => {
                let baseCardCheck = this.formData.skryhzh ? this.verifyBaseBankCardNo(this.formData.skryhzh) : this.formData.fkzh ? this.verifyBaseBankCardNo(this.formData.fkzh) : this.formData.yhzh ? this.verifyBaseBankCardNo(this.formData.yhzh) : null
                if (baseCardCheck) {
                    this.$notify({type: 'warning', message: baseCardCheck});
                    reject(data)
                }
                //判断是否是差旅补助流程
                if (this.groupId == 26) {
                    this.validateOverLap()
                }
                let bankCardCheck = this.formData.skryhzh ? this.verifyBankCardNo(this.formData.skryhzh) : this.formData.fkzh ? this.verifyBankCardNo(this.formData.fkzh) : this.formData.yhzh ? this.verifyBankCardNo(this.formData.yhzh) : null
                if (bankCardCheck) {
                    await this.$dialog.confirm({message: '<strong>请仔细核实收款账号，错误或不匹配的的账号、账户名、开户行会影响转账，确认提交吗？</strong>'}).then(() => {
                        this.$loading.show()
                        saveForm(data).then(res => {
                            this.$loading.hide()
                            resolve(data)
                        })
                    }).catch(() => {
                        return
                    })
                } else {
                    this.$loading.show()
                    saveForm(data).then(res => {
                        this.$loading.hide()
                        resolve(data)
                    })
                }
            })
        },
        /**
         * @description:获取自建应用sdk
         * @author: 孙小梅
         * @param {*}
         */
        registerWw() {
            return new Promise((resolve, reject) => {
                getTicket().then(res => {
                    ww.register({
                        corpId: 'ww5b7b6b536dc90edd', // 企业corpId
                        jsApiList: ['previewFile', 'getLocation'],
                        getConfigSignature() {
                            return ww.getSignature(res.ticket)
                        }
                    })
                    resolve();
                }).catch(e => {
                    console.error('后台获取ticket数据失败:', e)
                    reject(e);
                });
            });
        },
        /**
         * @description:获取三方应用sdk
         * @author: 孙小梅
         * @param {*}
         */
        async wwRegister(url, callback) {
            // 正式环境
            // let uri = `https://dev.nmgheli.com/wechat/getWxConfig?url=${url}&corpid=${localStorage.getItem('corpid')}`;
            // 测试环境
            // let uri = `https://ruixin.nmgheli.com/wechat/getWxConfig?url=${url}&corpid=${localStorage.getItem('corpid')}`;

            const baseENV = process.env.NODE_ENV || 'production';
            const baseURL = process.env.VUE_APP_BASE_URL || 'https://dev.nmgheli.com';
            let uri = `${baseURL}/wechat/getWxConfig?url=${url}&corpid=${localStorage.getItem('corpid')}`;
            let suiteId = baseENV === 'test' ? 'ww558bfc7ac5e7478d' : 'ww7e322b4f7efae65e';

            const res = await axios.get(uri);
            const { ticket, agentid } = res.data.data;
            window.ww.register({
                corpId: localStorage.getItem('corpid'),
                agentId: agentid,
                suiteId: suiteId,
                jsApiList: ['previewFile', 'getLocation'],
                getAgentConfigSignature() {
                    console.log('ww.getSignature444', window.ww.getSignature(res.data.data.ticket));
                    return window.ww.getSignature(ticket);
                },
            });
            if (callback && typeof callback === 'function') {
                callback(window.ww);
            }
        },
        // 加签
        counterSign(isSubmit, comments, multiAddUserInfo) {
            console.log(isSubmit, comments, multiAddUserInfo)
            const data = {
                comments: comments || '',
                taskId: this.taskId,
                processInstanceId: this.processInstanceId,
                formData: this.formData,
                multiAddUserInfo: multiAddUserInfo
            }
            return new Promise((resolve, reject) => {
                counterSign(data).then(res => {
                    this.$toast(res.msg, {duration: 500})
                    setTimeout(() => {
                        resolve()
                    }, 500)
                })
            })

        },
        // 转办
        transmit(isSubmit, comments, transferUserInfo) {
            this.$loading.show()
            const data = {
                comments: comments || '',
                taskId: this.taskId,
                processInstanceId: this.processInstanceId,
                formData: this.formData,
                transferUserInfo: transferUserInfo
            }

            return new Promise((resolve, reject) => {
                chgAssignee(data).then(res => {
                    this.$toast(res.msg, {duration: 500})
                    setTimeout(() => {
                        resolve()
                    }, 500)
                })
            })
        },
        // 这个方法必须返回Promise 但是不能resolve() 但是实际这个地方不能触发后续的代码
        resend() {
            return new Promise((resolve, reject) => {
                const query = {
                    ...this.$route.query,
                    reSend: 'true',
                    processInstanceId: this.processInstanceId
                }
                this.$router.push({
                    path: '/flowRedirect',
                    query
                })
                // 手动清理流程缓存
                this.CLEAR()
            })
        },
        //  拒绝
        refuse(isSubmit, comments) {
            this.$loading.show()
            const data = {
                comments: comments,
                taskId: this.taskId,
                processInstanceId: this.processInstanceId,
                formData: this.formData
            };
            return new Promise((resolve, reject) => {

                refuseAPI(data).then(res => {
                    this.$toast(res.msg, {duration: 500})
                    setTimeout(() => {
                        resolve()
                    }, 500)
                })
            })
        },
        //  退回
        onBack(isSubmit, comments) {
            this.$loading.show()
            const data = {
                comments: comments,
                taskId: this.taskId,
                processInstanceId: this.processInstanceId,
                formData: this.formData
            };
            return new Promise((resolve, reject) => {

                onBackAPI(data).then(res => {
                    this.$toast(res.msg, {duration: 500})
                    setTimeout(() => {
                        resolve()
                    }, 500)
                })
            })
        },
        // 撤销
        revoke() {
            return new Promise((resolve, reject) => {
                this.$dialog.confirm({
                    message: '确定要撤销该申请吗？',
                }).then(res => {
                    this.$loading.show()
                    taskRevoke({processInstanceId: this.processInstanceId}).then(res => {
                        this.$toast(res.msg, {duration: 500})
                        setTimeout(() => {
                            resolve()
                        }, 500)
                    })
                }).catch(err => {
                    reject('撤销确认框点击了取消')
                })
            })
        },
        // 评论
        mention(data, successFn) {
            const formData = JSON.parse(JSON.stringify(data))
            formData.instanceId = this.processInstanceId
            formData.taskId = this.taskId
            commentAPI(formData).then(res => {
                this.getProcessInfo({taskId: this.taskId, processInstanceId: this.processInstanceId})
                successFn()
            })
        },
        // 撤回
        reject() {
            return new Promise((resolve, reject) => {
                this.$dialog.confirm({
                    message: '确定撤回吗？',
                }).then(res => {
                    this.$loading.show()
                    const data = {
                        taskId: this.taskId,
                        processInstanceId: this.processInstanceId,
                    }
                    rejectFlowAPI(data).then(res => {
                        this.$toast(res.msg, {duration: 500})
                        setTimeout(() => {
                            resolve()
                        }, 500)
                    })
                }).catch(err => {
                    reject('撤回确认框点击了取消')
                })
            })
        },
        // 审批通过
        agree(isSubmit, comments) {
            this.$loading.show()
            const data = {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                formData: this.formData,
                comments
            };
            return new Promise((resolve, reject) => {
                agreeAPI(data).then(res => {
                    this.$toast(res.msg, {duration: 500})
                    setTimeout(() => {
                        resolve()
                    }, 500)
                })
            })
        },
        // 发起一个新流程
        start(isSubmit) {
            this.$loading.show()
            return new Promise((resolve, reject) => {
                const data = {
                    templateId: this.templateId,
                    submit: isSubmit,
                    formData: this.formData,
                    processUsers: this.$refs.approver.getProcessUsers(),
                    allProcessUsers: this.$refs.approver.getAllProcessUsers(),
                };
                flowStartAPI(data).then(res => {
                    this.$loading.hide();
                    resolve(data)
                })
            })
        },
        // 获取表单校验规则，校验规则可以在data中通过rules字段自定义，默认会合并后台校验规则 + 自定义校验规则（非必填）
        getRules(field) {
            // console.log(this.perms,this.rules,'console.log(this.perms,this.rules)')
            try {

                // this.perms是一定有值的 这里只是为了避免在异步加载时函数重复执行
                if (!this.perms || this.perms.length === 0) return;
                const item = this.perms.find(item => item.id === field);
                if (item) return [{
                    // 如果字段属于只读字段，则一律不校验
                    required: item.perm === 'R' ? false : item.required,
                    message: `${item.title}不能为空`,
                }, ...this.rules[field] || []];
                return this.rules[field] || [];
            } catch (err) {
                console.error('这个错一般是因为this.rules取到了空，需要在自己的页面中加入rules字段，空对象也行', err)
            }
        },
        // 是否展示
        isShow(field) {
            // console.log(this.perms)
            if (this.perms.length > 0) {
                const item = this.perms.find(item => item.id === field)
                if (!item) {
                    return false
                }
                return item.perm === 'H' ? false : true
            }
        },
        // 是否禁用
        // 注意区分v-if用和:disabled用是有区别的 v-if需要取反
        isDisabled(field) {
            if (this.perms) {
                const item = this.perms.find(item => item.id === field)
                if (this.processInstanceId) {
                    if (this.submitInfo.canHandle) {
                        if (item) return item.perm === 'R' ? true : false
                    } else {
                        return true
                    }
                } else {
                    if (item) return item.perm === 'R' ? true : false
                }
            }
        },
        // 是否显示form-item 中的*
        isRequired(field) {
            if (this.perms.length > 0) {
                const item = this.perms.find(item => item.id === field)
                if (!item) return false;
                const bol = item.perm === 'R' ? true : false
                if (bol) { // 如果是只读状态 则不展示*
                    return false
                }
                return item.required
            }
        },
        // 使用这个必须保证所有的数据结构都和现有的数据结构一致
        popupSubmit(field, props) {
            const item = this.$refs[field].getValues()[0]
            this.$set(this[field], 'show', false)
            if (!props) {
                console.warn('没传props配置项，直接全量赋值')
                this.$set(this.formData, field, typeof item === 'object' ? item.label : item)
                return
            }
            this.$set(this.formData, field, item[props.value] + ',' + item[props.label])
        },
        // 选择项目不单要赋值，还得自动调用项目经理信息
        popupSubmitSsxm(field, props) {
            const item = this.$refs[field].getValues()[0]
            this.$set(this[field], 'show', false)
            this.$set(this.formData, field, item[props.value] + ',' + item[props.label])
            this.$refs.approver.setProjectLeader(this.formData)
        },

        /**
         * 全局picker组件的搜索逻辑 使用这个方法必须保证所有的数据结构都和现有的数据结构一致
         * @param text
         * @param deploy 数据源和用于展示的过滤数据源
         * @param key 搜索的key 没有就说明源数据不是两层
         * @param valueKey 展示的valueKey 没有就说明是源数据字段
         */
        pickerSearch(text, deploy, key, valueKey) {
            deploy.filteredData = deploy.data.filter(item => {
                columnsLabel: `${item.type}-${item.name}`
                return key ? item[key].indexOf(text) !== -1 : item.indexOf(text) !== -1
            })
            if (valueKey) {
                deploy.filteredData = deploy.filteredData.map(item => ({
                    ...item,
                    [valueKey]: `${item.type}-${item.name}`
                }))
            }
        },
        // 用于管理动态table中的treeSearch
        treeSearch(text, treeDom) {
            let dom = treeDom.length ? treeDom[0] : treeDom
            dom.filter(text);
        },
        // 用于判断form-item种Popup组件是否要禁用
        isShowPopup(data, field) {
            if (!this.isDisabled(field)) {
                data.show = true
            }
        },
        // 用于管理动态table中的popup控件显隐
        popupHidden(list, index) {
            this.$set(list, index, false);
        },
        // 用于管理动态table中的popup控件显隐
        popupShow(list, index, field) {
            if (this.isDisabled(field)) { // 是否只读
                return
            }
            this.$set(list, index, true);
        },
        // 金额转换大型
        getChinese(money) {
            return money ? convertCurrency(money) : ''
        },
        // 金额千分位
        getFormatValue(val) {
            return val ? formatMoney(val) : '';
        },
        reserveLength(val) {
            // 如果小数点后面有两位小数则保留全部，如果没有则补全两位小数
            if (val.toString().split(".")[1]) {
                if (val.toString().split(".")[1].length >= 2) {
                    return val;
                } else {
                    return val.toString().split(".")[0] + "." + val.toString().split(".")[1] + "0";
                }
            } else {
                return val + ".00";
            }
        },
        _getDeptUserTreeAll(treeList) {
            // 使用箭头函数来保持对 Vue 组件实例的 this 的引用
            const processTree = (originalItems) => {
                const newItems = []; // 创建一个新数组来存储处理过的节点
                originalItems.forEach(item => {
                    const newItem = {...item}; // 创建一个新对象来避免修改原始数据
                    newItem.disabled = newItem.id >= 1000000;
                    newItem.uuid = this.uuid(); // 确保正确访问 Vue 组件实例的方法
                    newItem.name = item.label // 使用 label 替换 name，name需要在流程跟踪选人时候使用

                    if (newItem.children && newItem.children.length > 0) {
                        newItem.children = processTree(newItem.children); // 递归调用并更新 children
                    }
                    newItems.push(newItem); // 将处理过的节点添加到新数组中
                });
                return newItems; // 返回新数组
            };

            return processTree(treeList); // 启动递归处理并返回新的树列表
        },
        // 单选
        singleChoice(event, dom) {
            if (dom.length) { // 当元素在循环体中时
                dom = dom[0]
            }
            const len = dom.getCheckedNodes().length
            if (len > 1) {
                dom.setCheckedKeys([])
                dom.setCheckedNodes([event])
            }
        },
        // 过滤节点
        filterNode(value, data) {
            if (!value) return true;
            return data.label ? data.label.indexOf(value) !== -1 : data.name.indexOf(value) !== -1;
        },
        // 生成32位UUID
        uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";
            var uuid = s.join("");
            return uuid;
        },
        /**
         * 基于stroe中数据,修改字段信息显示隐藏 E H R
         * @param itemId : 字段id
         * @param chgValue 要修改为 E H R
         **/
        changeItemShow(itemId, chgValue) {
            if (store.state.process.perms.length > 0) {
                let item = store.state.process.perms.find(item => item.id === itemId)
                item.perm = chgValue
            }
        },

        /**
         * 基于stroe中数据,修改字段信息是否必填
         * @param itemId : 字段id
         * @param chgValue 要修改为 true false
         **/
        changeItemRequire(itemId, chgValue) {
            if (store.state.process.perms.length > 0) {
                let item = store.state.process.perms.find(item => item.id === itemId)
                item.required = chgValue
            }
        }
    },

}
